export default __webpack_public_path__ + "8f425c3fd650b91e85b08aa5e54931da.png";